import { render, staticRenderFns } from "./SaleGlobalFilter.vue?vue&type=template&id=9a0fa120&scoped=true&lang=html&"
import script from "./SaleGlobalFilter.vue?vue&type=script&lang=js&"
export * from "./SaleGlobalFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0fa120",
  null
  
)

export default component.exports